var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c("div", { staticClass: "f-box" }, [
      _c(
        "div",
        { staticStyle: { width: "49%" } },
        [
          _c(
            "el-carousel",
            {
              staticStyle: { "border-radius": "0px" },
              attrs: {
                arrow: "never",
                height: "170px",
                "indicator-position": "none",
              },
            },
            _vm._l(_vm.bannerList, function (item, index) {
              return _c(
                "el-carousel-item",
                { key: index },
                [
                  _c("el-image", {
                    staticStyle: { width: "100%", height: "100%" },
                    attrs: {
                      src: item.bannerPic
                        ? item.bannerPic
                        : require("@/assets/customPage/" +
                            _vm.$props.itemDetail.componentCode +
                            "_ba.png"),
                      fit: "cover",
                    },
                  }),
                ],
                1
              )
            }),
            1
          ),
        ],
        1
      ),
      _vm._v(" "),
      _vm.$props.itemDetail.componentSubcode === "v_ba_p_2"
        ? _c(
            "div",
            {
              staticStyle: {
                width: "49%",
                display: "flex",
                "flex-direction": "column",
                "justify-content": "space-between",
                height: "170px",
              },
            },
            _vm._l(_vm.dataList, function (item, index) {
              return _c(
                "div",
                { key: index, staticStyle: { height: "49%" } },
                [
                  _c("el-image", {
                    key: index,
                    staticStyle: {
                      width: "100%",
                      height: "100%",
                      display: "block",
                    },
                    attrs: {
                      src: item.bannerPic
                        ? item.bannerPic
                        : require("@/assets/customPage/" +
                            _vm.$props.itemDetail.componentSubcode +
                            ".png"),
                      fit: "cover",
                    },
                  }),
                ],
                1
              )
            }),
            0
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.$props.itemDetail.componentSubcode === "v_ba_p_3"
        ? _c(
            "div",
            {
              staticStyle: {
                width: "49%",
                display: "flex",
                "flex-direction": "column",
                "justify-content": "space-between",
                height: "170px",
              },
            },
            [
              _vm._l(
                _vm.dataList.filter(function (m, n) {
                  return n === 0
                }),
                function (item, index) {
                  return _c(
                    "div",
                    { key: index, staticStyle: { height: "49%" } },
                    [
                      _c("el-image", {
                        key: index,
                        staticStyle: {
                          width: "100%",
                          height: "100%",
                          display: "block",
                        },
                        attrs: {
                          src: item.bannerPic
                            ? item.bannerPic
                            : require("@/assets/customPage/" +
                                _vm.$props.itemDetail.componentSubcode +
                                "_" +
                                (index + 1) +
                                ".png"),
                          fit: "cover",
                        },
                      }),
                    ],
                    1
                  )
                }
              ),
              _vm._v(" "),
              _c(
                "div",
                {
                  staticStyle: {
                    height: "49%",
                    display: "flex",
                    "justify-content": "space-between",
                  },
                },
                _vm._l(
                  _vm.dataList.filter(function (m, n) {
                    return n != 0
                  }),
                  function (item, index) {
                    return _c(
                      "div",
                      { key: index, staticStyle: { width: "49%" } },
                      [
                        _c("el-image", {
                          key: index,
                          staticStyle: {
                            width: "100%",
                            height: "100%",
                            display: "block",
                          },
                          attrs: {
                            src: item.bannerPic
                              ? item.bannerPic
                              : require("@/assets/customPage/" +
                                  _vm.$props.itemDetail.componentSubcode +
                                  "_" +
                                  (index + 2) +
                                  ".png"),
                            fit: "cover",
                          },
                        }),
                      ],
                      1
                    )
                  }
                ),
                0
              ),
            ],
            2
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.$props.itemDetail.componentSubcode === "v_ba_p_5"
        ? _c(
            "div",
            {
              staticStyle: {
                width: "49%",
                display: "flex",
                "flex-direction": "column",
                "justify-content": "space-between",
                height: "170px",
              },
            },
            [
              _vm._l(
                _vm.dataList.filter(function (m, n) {
                  return n === 0
                }),
                function (item, index) {
                  return _c(
                    "div",
                    { key: index, staticStyle: { height: "49%" } },
                    [
                      _c("el-image", {
                        key: index,
                        staticStyle: {
                          width: "100%",
                          height: "100%",
                          display: "block",
                        },
                        attrs: {
                          src: item.bannerPic
                            ? item.bannerPic
                            : require("@/assets/customPage/" +
                                _vm.$props.itemDetail.componentSubcode +
                                "_" +
                                (index + 1) +
                                ".png"),
                          fit: "cover",
                        },
                      }),
                    ],
                    1
                  )
                }
              ),
              _vm._v(" "),
              _c(
                "div",
                {
                  staticStyle: {
                    height: "49%",
                    display: "flex",
                    "justify-content": "space-between",
                    "flex-direction": "column",
                  },
                },
                [
                  _c(
                    "div",
                    {
                      staticStyle: {
                        height: "49%",
                        display: "flex",
                        "justify-content": "space-between",
                      },
                    },
                    _vm._l(
                      _vm.dataList.filter(function (m, n) {
                        return n == 1 || n == 2
                      }),
                      function (item, index) {
                        return _c(
                          "div",
                          { key: index, staticStyle: { width: "49%" } },
                          [
                            _c("el-image", {
                              key: index,
                              staticStyle: {
                                width: "100%",
                                height: "100%",
                                display: "block",
                              },
                              attrs: {
                                src: item.bannerPic
                                  ? item.bannerPic
                                  : require("@/assets/customPage/" +
                                      _vm.$props.itemDetail.componentSubcode +
                                      "_" +
                                      (index + 2) +
                                      ".png"),
                                fit: "cover",
                              },
                            }),
                          ],
                          1
                        )
                      }
                    ),
                    0
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      staticStyle: {
                        height: "49%",
                        display: "flex",
                        "justify-content": "space-between",
                      },
                    },
                    _vm._l(
                      _vm.dataList.filter(function (m, n) {
                        return n == 3 || n == 4
                      }),
                      function (item, index) {
                        return _c(
                          "div",
                          { key: index, staticStyle: { width: "49%" } },
                          [
                            _c("el-image", {
                              key: index,
                              staticStyle: {
                                width: "100%",
                                height: "100%",
                                display: "block",
                              },
                              attrs: {
                                src: item.bannerPic
                                  ? item.bannerPic
                                  : require("@/assets/customPage/" +
                                      _vm.$props.itemDetail.componentSubcode +
                                      "_" +
                                      (index + 4) +
                                      ".png"),
                                fit: "cover",
                              },
                            }),
                          ],
                          1
                        )
                      }
                    ),
                    0
                  ),
                ]
              ),
            ],
            2
          )
        : _vm._e(),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }